import { render, staticRenderFns } from "./ForbiddenContent.vue?vue&type=template&id=0d634e29&scoped=true"
import script from "./ForbiddenContent.vue?vue&type=script&lang=js"
export * from "./ForbiddenContent.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenContent.vue?vue&type=style&index=0&id=0d634e29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d634e29",
  null
  
)

export default component.exports